// ===============================================
// 3. QuickFilterChips.jsx - NEW COMPONENT
// ===============================================

import { Box, Typography, Chip } from '@mui/material';
import { Star as StarIcon, LocationOn as LocationIcon } from '@mui/icons-material';

const QuickFilterChips = ({ 
  category, 
  setCategory, 
  categoryOptions, 
  ratingFilter, 
  setRatingFilter,
  maxDistance,
  setMaxDistance 
}) => {
  const popularCategories = categoryOptions.slice(1, 4); // Get top 3 categories after "All"
  
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
        Quick filters:
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {/* Popular Categories */}
        {popularCategories.map((cat) => (
          <Chip
            key={cat.value}
            label={`${cat.label} (${cat.count})`}
            onClick={() => setCategory(cat.value)}
            variant={category === cat.value ? 'filled' : 'outlined'}
            color={category === cat.value ? 'primary' : 'default'}
            size="small"
          />
        ))}
        
        {/* Rating Shortcuts */}
        <Chip
          label="4+ Stars"
          onClick={() => setRatingFilter(4)}
          variant={ratingFilter >= 4 ? 'filled' : 'outlined'}
          color={ratingFilter >= 4 ? 'primary' : 'default'}
          size="small"
          icon={<StarIcon />}
        />
        
        {/* Distance Shortcuts */}
        <Chip
          label="Within 5 mi"
          onClick={() => setMaxDistance(5)}
          variant={maxDistance === 5 ? 'filled' : 'outlined'}
          color={maxDistance === 5 ? 'primary' : 'default'}
          size="small"
          icon={<LocationIcon />}
        />
      </Box>
    </Box>
  );
};

export default QuickFilterChips;